module.exports = __webpack_public_path__ + "static/media/shyam_image.6b412a86.png";